<script lang="ts">
	import type { Store, SearchField, SearchFieldProps } from 'utility/search-fields'

	import EditModeControls from './EditModeControls.svelte'
	import Pin from './Pin.svelte'

	interface Props extends SearchFieldProps<Array<number>> {
		id?: string
		stores: Store[]
		selectedStores: number[]
		initialValue?: number[]
	}

	let {
		id = 'stores',
		searchField,
		inEditMode,
		pinnedSearchFields,
		selectedSearchFieldsKeys,
		stores,
		selectedStores = $bindable(),
		disabled = false,
		initialValue = [],
		change,
	}: Props = $props()

	// Initialize selectedStores with initialValue if provided
	if (initialValue.length > 0) {
		selectedStores = initialValue
	}
</script>

<EditModeControls
	{searchField}
	{inEditMode}
	{pinnedSearchFields}
	{selectedSearchFieldsKeys}
>
	<!--
		NOTE: We're not using our Select component here because of an issue with the `multiple` attribute.
		Instead of getting an array back, you just get the last clicked value.
		When that issue is resolved, we can switch back to using our Select component since the Select now has a `hint` slot.
	-->
	<div class="form-group mb-1">
		<label for="stores"
			>Stores
			<Pin isPinned={pinnedSearchFields.has(searchField.key)} />
		</label>
		<select
			{id}
			class="form-control form-control-sm"
			multiple
			disabled={disabled || inEditMode}
			bind:value={selectedStores}
			onchange={() => change?.({ field: searchField, value: selectedStores })}
		>
			{#each stores as store}
				<option value={store.id}>{store.code} - {store.name}</option>
			{/each}
		</select>
	</div>
</EditModeControls>
